<template>
  <b-modal v-model="show" title="Testar Integração" size="lg" ok-only ok-title="Fechar">
    <div v-if="loading" class="text-center py-4">
      <b-spinner /><br>
      <small class="text-muted mt-1 d-block">Executando chamada...</small>
    </div>
    <template v-else-if="resultado">
      <div class="mb-1">
        <strong>{{ integracaoNome }}</strong>
        <b-badge :variant="resultado.sucesso ? 'light-success' : 'light-danger'" class="ml-50">
          {{ resultado.sucesso ? 'Sucesso' : 'Falha' }}
        </b-badge>
      </div>
      <b-row class="mb-1">
        <b-col md="3" sm="6" cols="6" class="mb-50">
          <small class="text-muted d-block">Status HTTP</small>
          <b-badge :variant="statusVariant(resultado.status_http)" class="h6 mb-0">{{ resultado.status_http || '—' }}</b-badge>
        </b-col>
        <b-col md="3" sm="6" cols="6" class="mb-50">
          <small class="text-muted d-block">Tempo</small>
          <strong>{{ resultado.tempo_ms }} ms</strong>
        </b-col>
        <b-col md="6" sm="12" cols="12" class="mb-50">
          <small class="text-muted d-block">Método / URL</small>
          <div class="metodo-url">
            <b-badge variant="light-secondary" class="mr-50">{{ resultado.metodo }}</b-badge>
            <span class="url-text" :title="resultado.url">{{ resultado.url }}</span>
          </div>
        </b-col>
      </b-row>
      <b-alert v-if="resultado.error" show variant="danger">
        <feather-icon icon="AlertTriangleIcon" class="mr-50" />
        <strong>Erro:</strong> {{ resultado.error }}
      </b-alert>
      <div>
        <small class="text-muted d-block mb-25">Resposta</small>
        <pre class="response-box">{{ formatResponse(resultado.response) }}</pre>
      </div>
    </template>
    <div v-else class="text-center py-3 text-muted">Nenhum teste executado.</div>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'TestarIntegracaoModal',
  data() {
    return {
      show: false,
      loading: false,
      resultado: null,
      integracaoNome: '',
    };
  },
  methods: {
    ...mapActions('IntegracaoErp', ['testar']),
    async open(item) {
      this.show = true;
      this.loading = true;
      this.resultado = null;
      this.integracaoNome = item.nome || '';
      try {
        this.resultado = await this.testar(item.integracaoid);
      } catch (e) {
        this.resultado = { sucesso: false, status_http: 0, tempo_ms: 0, response: '', error: e.message || 'Erro ao executar teste', url: item.url, metodo: item.metodo };
      } finally {
        this.loading = false;
      }
    },
    statusVariant(code) {
      if (!code) return 'light-secondary';
      if (code >= 200 && code < 300) return 'light-success';
      if (code >= 300 && code < 400) return 'light-info';
      if (code >= 400 && code < 500) return 'light-warning';
      return 'light-danger';
    },
    formatResponse(r) {
      if (!r) return '(resposta vazia)';
      try { return JSON.stringify(JSON.parse(r), null, 2); } catch (e) { return r; }
    },
  },
};
</script>

<style scoped>
.response-box {
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px 12px;
  max-height: 280px;
  overflow: auto;
  font-size: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  white-space: pre-wrap;
  word-break: break-word;
}
.metodo-url {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 4px;
  min-width: 0;
}
.url-text {
  word-break: break-all;
  overflow-wrap: anywhere;
  font-size: 0.85rem;
  line-height: 1.3;
  flex: 1 1 auto;
  min-width: 0;
}
</style>
